import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Company } from 'src/app/shared/models';
import { StringHelpers } from 'src/app/shared/helpers/string-helpers';

@Component({
    selector: 'app-navbar',
    templateUrl: './navbar.component.html',
    styleUrls: ['./navbar.component.scss'],
    standalone: false
})
export class NavbarComponent implements OnInit {
  @Input() restaurant: Company;
  @Input() canGoBack: boolean = true;
  @Output() onBack: EventEmitter<any> = new EventEmitter();

  deparameterize = StringHelpers.deparameterize;

  constructor() { }

  ngOnInit(): void {
  }
}
